import { BaseService } from '../../../infra/base.service'
import { FormV2FormLinksRepository } from './form-v2-form-links.repository'
import type { FormV2FormLink } from './form-v2-form-link'

export class FormV2FormLinksService extends BaseService<FormV2FormLink> {
    constructor(private rep: FormV2FormLinksRepository) {
        super(rep)
    }
}
